const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:3000";

const REACT_APP_RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

const REACT_APP_RAZORPAY_SECRET = process.env.REACT_APP_RAZORPAY_SECRET;

const environment = process.env.REACT_APP_ENVIRONMENT;

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyAGcvTlMQzz4GGNqjPSPoe3lHOAbg-NTs0";

export { BASE_URL, REACT_APP_RAZORPAY_KEY_ID, GOOGLE_MAPS_API_KEY,REACT_APP_RAZORPAY_SECRET,environment};


